import { Swiper } from 'swiper';
import { Navigation } from 'swiper/modules';

const sliders = document.querySelectorAll('.block-media-slider-grid .swiper');

if (sliders.length > 0) {
	sliders.forEach((slider) => {
		const navigationButtons = slider.parentElement.querySelectorAll(
			'.swiper-button-prev, .swiper-button-next'
		);
		const showNavigation = () => {
			navigationButtons.forEach((button) => {
				button.classList.remove(
					'swiper-button-lock',
					'block-media-slider-grid__button-lock'
				);
			});
		};
		const settings = {
			loop: true,
			grabCursor: true,
			watchOverflow: false,
			spaceBetween: 10,
			slidesPerView: 1,
			modules: [Navigation],
			navigation: {
				prevEl: slider.parentElement.querySelector(
					'.swiper-button-prev'
				),
				nextEl: slider.parentElement.querySelector(
					'.swiper-button-next'
				),
				lockClass: 'block-media-slider-grid__button-lock',
			},
			on: {
				afterInit: showNavigation,
				update: showNavigation,
				resize: showNavigation,
			},
		};

		new Swiper(slider, settings);
	});
}
